export default class OwnerGroupDto {
    constructor(obj) {
        this.groupId = obj.groupId // Int
        this.communalAccount = obj.communalAccount // String
        this.cityCode = obj.cityCode // String
        this.ownerId = obj.ownerId // Int
        this.ownerType = obj.ownerType // Int
    }
}